import React from 'react';
import { CircularProgress, IconButton, ListItem, ListItemText } from '@mui/material';
import { Delete } from '@mui/icons-material';

import { useUnassignBuildingsToUserMutation } from 'store/apis';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

export interface AssignedBuildingProps {
  userId: number;
  buildingId: number;
  title?: string;
  subtitle?: string;
}

export const AssignedBuilding = ({ userId, buildingId, title = '', subtitle = '' }: AssignedBuildingProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [mutate, { isLoading }] = useUnassignBuildingsToUserMutation();

  return (
    <ListItem
      secondaryAction={
        <IconButton
          color="primary"
          onClick={() => mutate({ orgSlug, userId, buildingId })}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 40,
          }}
          disabled={isLoading}
        >
          {isLoading ? <CircularProgress size={18} /> : <Delete />}
        </IconButton>
      }
    >
      <ListItemText primary={title} secondary={subtitle} />
    </ListItem>
  );
};
